import api from "../../infra/api";

class servSolicitacaoCompartilhamentoPontos {
    async listar(codigoSolicCompart) {
        const response = await api({
            method: "GET",
            url: `/api/v1/SolicitacaoCompartilhamentoPontos?page=1&start=0&limit=99999&fields=["Id","CodigoSolicCompart","Analise","CodigoPontoSc","DescricaoPontoSc","CodigoUsoMutuoPc","CodigoUsoMutuo","Longitude","Latitude","TemOcupacao","QtdeUsoMutuo"]&sort=[{"property":"CodigoPontoSc","direction":"DESC"}]&filter=[{"property":"CodigoSolicCompart","value":"${codigoSolicCompart}","and":false}]`
        });

        return response.data;
    }

    async inserir(listaPontos, solicitacaoCompartilhamento, codeAnalise) {
        const newList = [];
        listaPontos.forEach(pontos => {
            newList.push({
                CodigoSolicCompart: solicitacaoCompartilhamento,
                CodigoAnalise: codeAnalise,
                CodigoPontoSc: pontos.Codigo,
                DescricaoPontoSc: pontos.Descricao,
                Longitude: pontos.Lng,
                Latitude: pontos.Lat,
                TemOcupacao: 0,
                QtdeUsoMutuo: pontos.QtdeUsoMutuo
            })
        });
        const response = await api({
            method: "POST",
            url: "api/v1/SolicitacaoCompartilhamentoPontos",
            headers: {
                "Content-Type": "application/json",
            },
            data: JSON.stringify(newList)
        });

        return response.data;
    }

    async editar(listaPontos, solicitacaoCompartilhamento) {
        const newList = {
            Id: listaPontos.Id,
            CodigoSolicCompart: solicitacaoCompartilhamento,
            CodigoPontoSc: listaPontos.Codigo,
            DescricaoPontoSc: listaPontos.Descricao,
            Longitude: listaPontos.Lng,
            Latitude: listaPontos.Lat,
            TemOcupacao: listaPontos.TemOcupacao,
            QtdeUsoMutuo: listaPontos.QtdeUsoMutuo
        }
        const response = await api({
            method: "PUT",
            url: "api/v1/SolicitacaoCompartilhamentoPontos",
            headers: {
                "Content-Type": "application/json",
            },
            data: JSON.stringify(newList)
        });

        return response.data;
    }

    async RemoverPonto(codigoPonto) {
        const response = await api({
            method: "DELETE",
            url: `api/v1/SolicitacaoCompartilhamentoPontos/RemoverPonto/${codigoPonto}`
        });

        return response.data;
    }

    async MarcarTemOcupacao(dto) {
        const response = await api({
            method: "PUT",
            url: "api/v1/SolicitacaoCompartilhamentoPontos/MarcarTemOcupacao",
            headers: {
                "Content-Type": "application/json",
            },
            data: JSON.stringify({ CodigoPontos: dto })
        });

        return response.data;
    }

    async RemoverPontos(solicitacaoCompartilhamento) {
        const response = await api({
            method: "DELETE",
            url: `api/v1/SolicitacaoCompartilhamentoPontos/RemoverPontos/${solicitacaoCompartilhamento}`,
        });

        return response.data;
    }

    async DesmarcarTemOcupacao(dto) {
        const response = await api({
            method: "PUT",
            url: "api/v1/SolicitacaoCompartilhamentoPontos/DesmarcarTemOcupacao",
            headers: {
                "Content-Type": "application/json",
            },
            data: JSON.stringify({ CodigoPontos: dto })
        });

        return response.data;
    }
}

export default new servSolicitacaoCompartilhamentoPontos();